module.exports = __webpack_public_path__ + "media/assets/images/small-close-f7cbf61388233451b3d55a3dde818e7a.png";